<template>
	<headerSearch></headerSearch>
	<div class="w1440 personal_center">
		<div class="flex-box col90 ptb10 page_location">
			当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
			<div class="now_page">服务条款</div>
		</div>
		<div class="flex-box flex-col-start">
			<personal-nav :firstIndex="6" :secondIndex="-1"></personal-nav>
			<div class="ml10 flex-grow-1 part_r">
				<div class="fs18 col12 fwb tc">尊享服务，售后无忧</div>
				<div class="fs16 col90 tc mt5 mb35">小狮优选，为您甄选</div>
				<div class="flex-box item fs16 col04 cursor mb20" @click="toDetail(1, '用户协议')">用户协议</div>
				<div class="flex-box item fs16 col04 cursor mb20" @click="toDetail(2, '隐私政策')">隐私政策</div>
				<div class="flex-box item fs16 col04 cursor mb20" @click="toDetail(4, '服务条款')">服务条款</div>
			</div>
		</div>
	</div>
</template>

<script>
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
	setup() {
		onMounted(() => {
			useHead({
				title: "服务条款-小狮优选",
				meta: [
					{ name: "description", content: "This is my page description" },
					{ property: "og:title", content: "My Page Title" },
					{ property: "og:description", content: "This is my page description" },
					{ property: "og:url", content: "https://example.com/my-page" },
					{ property: "og:image", content: "https://example.com/my-image.jpg" },
				],
				link: [{ rel: "canonical", href: "https://example.com/my-page" }],
			})
		})
	},
	components: {
		PersonalNav,
	},
	data() {
		return {
			content: '',
		};
	},
	created() {
		this.getAgreement();
	},
	methods: {
		toDetail(index, name) {
			this.$router.push({ path: '/ServiceDetail', query: { id: index, name: name } });
		},
		getAgreement() {
			this.$api.getAgreement({ id: 4 }).then(res => {
				if (res.code == 1) {
					this.content = res.data.content;
				}
			})
		}
	},
};
</script>

<style lang="less" scoped>
.part_r {
	padding: 44px;
	background: #fff;

	.item {
		height: 80px;
		border-radius: 10px;
		border: 1px solid rgba(98, 134, 171, 0.6);
		padding: 0 44px 0 28px;

		&::before {
			content: "";
			display: block;
			width: 46px;
			height: 46px;
			background: url('../../../assets/static/icon/c_service_term.png') no-repeat center;
			background-size: 100%;
			margin-right: 20px;
		}

		&::after {
			content: "";
			display: block;
			width: 20px;
			height: 20px;
			background: url('../../../assets/static/icon/c_service_right.png') no-repeat center;
			background-size: 100%;
			margin-left: auto;
		}
	}
}
</style>
